import React from "react";
import { SUPPORT_PHONE } from "../../config/support";

export const PhoneIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

const HelpCard = () => (
  <section className="card help-card">
    <h2 className="card-title">Need help with this shipment?</h2>
    <p className="help-text">Questions about your delivery? Our support team is here to help.</p>

    <a className="btn-primary btn-block help-btn" href={`tel:${SUPPORT_PHONE.replace(/[^\d+]/g, "")}`}>
      <PhoneIcon />
      Contact support
    </a>
  </section>
);

export default HelpCard;
